import { FC } from 'react';

import { pick, isEmpty } from 'lodash';
import { AccountCard } from 'utils/types';

import CardLocation from '../assets/location.svg';
import CardLinkedin from '../assets/LinkedIn.svg';
import CardFacebook from '../assets/Facebook.svg';
import CardInstagram from '../assets/Instagram.svg';
import CardX from '../assets/X.svg';

type PROPS = {
  accountCard: AccountCard;
};

const ICONS = {
  address: CardLocation,
  linkedInUrl: CardLinkedin,
  facebookUrl: CardFacebook,
  instagramUrl: CardInstagram,
  xUrl: CardX,
};

const CardContactAdditionalDetails: FC<PROPS> = ({ accountCard }) => {
  const metaEntries = pick(accountCard.meta, [
    'address',
    'linkedInUrl',
    'facebookUrl',
    'instagramUrl',
    'xUrl',
  ]);

  if (Object.values(metaEntries).filter((value) => !isEmpty(value)).length < 1)
    return null;

  return (
    <>
      <p className="text-sm text-text-secondary font-semibold">
        Additional Details
      </p>
      <ul className="space-y-6">
        {Object.entries(metaEntries)
          // eslint-disable-next-line @typescript-eslint/no-unused-vars
          .filter(([_, value]) => !isEmpty(value))
          .map(([key, value]) => (
            <li key={key} className="flex space-x-2 items-center">
              <img
                src={ICONS[key as keyof typeof ICONS]}
                alt={key}
                className="inline-block mr-2"
              />
              <p className="text-sm text-text-secondary">{value}</p>
            </li>
          ))}
      </ul>
    </>
  );
};

export default CardContactAdditionalDetails;
